import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconChartPie12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconChartPie12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#ChartPie12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M10.975 6.5a5 5 0 1 1-5.487-5.474V6.5zm0-1H6.488V1.024A5 5 0 0 1 10.975 5.5M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="ChartPie12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconChartPie12);
